<template>
  <div class="closingEfficiency">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>办结效率
      </span>
      <!-- <span class="other more">更多</span> -->
    </div>
    <div class="closingEfficiency-main">
      <el-scrollbar style="height:100%;">
        <el-table
          :data="tableData"
          stripe
          :header-cell-style="{background:'#eff6ff',color:'#333333'}"
        >
          <el-table-column prop="taskType"  label="业务类型"></el-table-column>
          <el-table-column prop="taskNumber" width="150" label="业务总数(件)"></el-table-column>
          <el-table-column prop="complete" width="100" label="已完成(件)"></el-table-column>
          <el-table-column prop="waitNumber" width="100" label="未完成(件)"></el-table-column>
          <!-- <el-table-column prop="timeOutNumber" width="150" label="超期业务(件)"></el-table-column> -->
          <el-table-column prop="finshedPer" width="100" label="完成率"></el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';

export default {
  components: {},
  props: {},
  data() {
    return {
      Position: 'running',
      tableData: [
        {
          taskType: '行政备案',
          taskNumber: 12,
          complete: 12,
          waitNumber: 0,
          timeOutNumber: 0,
          finshedPer: '100%'
        },
        {
          taskType: '诚信申报',
          taskNumber: 12,
          complete: 12,
          waitNumber: 0,
          timeOutNumber: 0,
          finshedPer: '100%'
        }
      ]
    };
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss">
@import './css/common.scss';
.closingEfficiency {
  background-color: #fff;
  .closingEfficiency-main {
    text-align: center;
    height: 210px;
    .el-scrollbar__view {
      position: relative;
      .el-table {
        padding: 0 20px 20px 20px;
        position: absolute;
        width: auto;
        max-width: none;
      }
      .el-table::before {
        display: none;
      }
      .el-radio-group {
        margin-top: 15px;
        margin-bottom: 0 !important;
        .el-radio-button {
          .el-radio-button__inner {
            padding: 6px 20px;
          }
        }
      }
    }
  }
}
</style>